export const COUNTRIES = [
	{ value: 'ALL', text: 'All', textHu: 'Összes' },
	{ value: 'HUNGARY', text: 'Hungary', textHu: 'Magyarország' },
	{ value: 'FOREIGN', text: 'Foreign', textHu: 'Külföld' }
];
export const LANG = {
	HUN: 'HUN',
	ENG: 'ENG'
};
